var map = {
	"./angle-down.svg": 83801,
	"./angle-left.svg": 29410,
	"./angle-right.svg": 54873,
	"./angle-up.svg": 52246,
	"./ap-watch/arrow.png": 4139,
	"./arrow-breadcrumbs.svg": 26987,
	"./arrow-diagonal.svg": 4922,
	"./arrow-down.svg": 25979,
	"./arrow-left.svg": 17564,
	"./arrow-load-more.svg": 53323,
	"./arrow-right.svg": 62595,
	"./arrow-up.svg": 68564,
	"./artist-discovery/artist-1.png": 21670,
	"./artist-discovery/image 33.png": 65726,
	"./artist-discovery/image 34.png": 1841,
	"./artist-discovery/image 35.png": 61896,
	"./artist-discovery/image 36.png": 98755,
	"./artist-discovery/image 38.png": 81037,
	"./artist-discovery/leonthomas.png": 79323,
	"./benefit-curve-small.svg": 62252,
	"./benefit-curve.svg": 76166,
	"./benefit-empty-side.svg": 68164,
	"./benefit-empty-top.svg": 42586,
	"./calendar.svg": 16109,
	"./check.svg": 69173,
	"./chevron-right.svg": 68529,
	"./close.svg": 18081,
	"./download.svg": 6739,
	"./email-banner.jpg": 51379,
	"./external-link.svg": 53840,
	"./facebook.svg": 45323,
	"./favicons/android-icon-144x144.png": 84462,
	"./favicons/android-icon-192x192.png": 74174,
	"./favicons/android-icon-36x36.png": 80888,
	"./favicons/android-icon-48x48.png": 53470,
	"./favicons/android-icon-72x72.png": 40624,
	"./favicons/android-icon-96x96.png": 24004,
	"./favicons/apple-icon-114x114.png": 74109,
	"./favicons/apple-icon-120x120.png": 72469,
	"./favicons/apple-icon-144x144.png": 76857,
	"./favicons/apple-icon-152x152.png": 31665,
	"./favicons/apple-icon-180x180.png": 28801,
	"./favicons/apple-icon-57x57.png": 55777,
	"./favicons/apple-icon-60x60.png": 9845,
	"./favicons/apple-icon-72x72.png": 90991,
	"./favicons/apple-icon-76x76.png": 80815,
	"./favicons/apple-icon-precomposed.png": 81298,
	"./favicons/apple-icon.png": 75842,
	"./favicons/favicon-16x16.png": 13547,
	"./favicons/favicon-32x32.png": 2851,
	"./favicons/favicon-96x96.png": 90971,
	"./favicons/favicon.ico": 17476,
	"./favicons/ms-icon-144x144.png": 70515,
	"./favicons/ms-icon-150x150.png": 77551,
	"./favicons/ms-icon-310x310.png": 67667,
	"./favicons/ms-icon-70x70.png": 88389,
	"./file.svg": 14561,
	"./hamburger-menu.svg": 69136,
	"./icon-insider.png": 28850,
	"./icon-insider.svg": 85469,
	"./icons/arrow-next.svg": 74937,
	"./icons/arrow-previous.svg": 68473,
	"./icons/controls.svg": 43052,
	"./icons/dot.svg": 71491,
	"./icons/icon-boutique.svg": 84540,
	"./icons/icon-buy.svg": 32066,
	"./icons/icon-download.svg": 19946,
	"./icons/icon-insider.svg": 69168,
	"./icons/icon-partner-rec.svg": 7109,
	"./icons/icon-sponsored.svg": 6259,
	"./icons/icon-video.svg": 34927,
	"./icons/pick-colored.svg": 70260,
	"./icons/pick.svg": 56945,
	"./icons/tick.svg": 46549,
	"./info.svg": 59903,
	"./instagram.svg": 921,
	"./linkedin.svg": 7469,
	"./loading.gif": 42777,
	"./logo-mjf-2025-email.png": 38904,
	"./logo-mjf-2025.jpg": 16295,
	"./logo-mjf-2025.png": 21047,
	"./logo-mjf-2025.svg": 33944,
	"./logo-mjf-plectre.jpg": 26375,
	"./logo-mjf.svg": 1952,
	"./logo-superhuit.svg": 634,
	"./loop.svg": 21449,
	"./mail.svg": 97962,
	"./minus.svg": 11645,
	"./next.svg": 50920,
	"./pause.svg": 80871,
	"./placeholder/accor-black.svg": 87193,
	"./placeholder/accor-desktop-inverted.svg": 8114,
	"./placeholder/accor-desktop.svg": 73424,
	"./placeholder/accor-mobile-inverted.svg": 64576,
	"./placeholder/accor-mobile.svg": 32078,
	"./placeholder/accord-no-borders.svg": 29857,
	"./placeholder/article-banner-1-desktop.jpg": 12870,
	"./placeholder/article-banner-1-mobile.jpg": 1946,
	"./placeholder/article-banner-1.jpg": 38869,
	"./placeholder/article-banner-2-mobile.jpg": 25515,
	"./placeholder/article-breaker-sponsored.jpg": 99755,
	"./placeholder/article-breaker.jpg": 78965,
	"./placeholder/audemars-black.svg": 20823,
	"./placeholder/audemars-color.svg": 86719,
	"./placeholder/audemars-desktop-color.svg": 61360,
	"./placeholder/audemars-desktop-inverted.svg": 4720,
	"./placeholder/audemars-desktop.svg": 40798,
	"./placeholder/audemars-footer-desktop.svg": 67696,
	"./placeholder/audemars-mobile-color.svg": 68358,
	"./placeholder/audemars-mobile-inverted.svg": 57670,
	"./placeholder/audemars-mobile.svg": 81156,
	"./placeholder/audemars-no-borders-color.svg": 74479,
	"./placeholder/audemars-no-borders.svg": 38009,
	"./placeholder/british-black.svg": 36004,
	"./placeholder/british-desktop.svg": 20977,
	"./placeholder/british-mobile.svg": 66821,
	"./placeholder/card-article-big.jpg": 85460,
	"./placeholder/card-article-hero.jpg": 72804,
	"./placeholder/card-article-like.jpg": 98241,
	"./placeholder/card-article.jpg": 43373,
	"./placeholder/card-contact.jpg": 32975,
	"./placeholder/card-cta-image-only-image.png": 88082,
	"./placeholder/card-cta-image-only-logo.png": 37992,
	"./placeholder/card-cta-nav.jpg": 29925,
	"./placeholder/card-cta-no-icon.jpg": 48459,
	"./placeholder/card-cta-no-link.jpg": 30044,
	"./placeholder/card-cta.jpg": 90485,
	"./placeholder/card-package-train.png": 96574,
	"./placeholder/card-package.jpg": 74635,
	"./placeholder/card-shop-gift.jpg": 95648,
	"./placeholder/card-shop.jpg": 55871,
	"./placeholder/contact.jpg": 63152,
	"./placeholder/content-breaker-1.jpg": 88922,
	"./placeholder/content-breaker-1.png": 29598,
	"./placeholder/content-breaker-2.jpg": 93125,
	"./placeholder/content-breaker-link.jpg": 26535,
	"./placeholder/diageo-black.svg": 1678,
	"./placeholder/diageo-desktop.svg": 69427,
	"./placeholder/diageo-mobile.svg": 66631,
	"./placeholder/example-banner-co-partners.jpg": 11306,
	"./placeholder/example-banner-main-partners.jpg": 27533,
	"./placeholder/example-partners-article-header.jpg": 40451,
	"./placeholder/example-partners-footer.jpg": 97062,
	"./placeholder/example-partners-list-cards.jpg": 92833,
	"./placeholder/gallery/bon-iver-at-montreux-jazz-festival.jpg": 68359,
	"./placeholder/gallery/chemical-brothers-marcus-lyall-adam-smith-showjpg.jpg": 47639,
	"./placeholder/gallery/selah-sue-montreux-jazz-lab-2014-portrait.jpg": 34711,
	"./placeholder/gallery/selah-sue-montreux-jazz-lab-2014.jpg": 25255,
	"./placeholder/groupe-black.svg": 70941,
	"./placeholder/groupe-desktop.svg": 11340,
	"./placeholder/groupe-mobile.svg": 71266,
	"./placeholder/highlighted-content-no-link.jpg": 27490,
	"./placeholder/highlighted-content.jpg": 98323,
	"./placeholder/john_maclaughlin.jpg": 25469,
	"./placeholder/julius-footer-desktop.svg": 40954,
	"./placeholder/loterie-black.svg": 48511,
	"./placeholder/loterie-desktop.svg": 62374,
	"./placeholder/loterie-mobile.svg": 34940,
	"./placeholder/manor-black.svg": 66194,
	"./placeholder/manor-desktop-inverted.svg": 93335,
	"./placeholder/manor-desktop.svg": 34623,
	"./placeholder/manor-mobile-inverted.svg": 3299,
	"./placeholder/manor-mobile.svg": 22459,
	"./placeholder/media-header-default.jpg": 26304,
	"./placeholder/media-header-sponsored.jpg": 36602,
	"./placeholder/meyer-sound.jpg": 81516,
	"./placeholder/nestle-black.svg": 8500,
	"./placeholder/nestle-desktop.svg": 41249,
	"./placeholder/nestle-mobile.svg": 73717,
	"./placeholder/netflix.svg": 32515,
	"./placeholder/page-header-artist.png": 44309,
	"./placeholder/page-header-default.jpg": 62597,
	"./placeholder/page-header-home-new.png": 41824,
	"./placeholder/page-header-home-residency.jpg": 69506,
	"./placeholder/page-header-home-split.jpg": 56390,
	"./placeholder/page-header-home.jpg": 341,
	"./placeholder/page-header-no-credits.jpg": 66020,
	"./placeholder/page-header-partner.jpg": 15264,
	"./placeholder/primary-menu.jpg": 30704,
	"./placeholder/program-artist.png": 83466,
	"./placeholder/program-meyer-sound.png": 9723,
	"./placeholder/program-millenium.png": 41473,
	"./placeholder/socar-black.svg": 25289,
	"./placeholder/socar-desktop.svg": 13312,
	"./placeholder/socar-mobile.svg": 3390,
	"./placeholder/square-image.jpg": 76187,
	"./placeholder/square-image2.jpg": 2993,
	"./placeholder/superbock-black.svg": 76111,
	"./placeholder/superbock-color.svg": 31239,
	"./placeholder/superbock-desktop-color.svg": 81768,
	"./placeholder/superbock-desktop-inverted.svg": 40168,
	"./placeholder/superbock-desktop.svg": 77430,
	"./placeholder/superbock-footer-desktop.svg": 28539,
	"./placeholder/superbock-mobile-color.svg": 72942,
	"./placeholder/superbock-mobile-inverted.svg": 15598,
	"./placeholder/superbock-mobile.svg": 2380,
	"./placeholder/swisscom-footer-desktop.svg": 59140,
	"./placeholder/ubs-black.svg": 19657,
	"./placeholder/ubs-desktop-inverted.svg": 76162,
	"./placeholder/ubs-desktop.svg": 81184,
	"./placeholder/ubs-mobile-inverted.svg": 25840,
	"./placeholder/ubs-mobile.svg": 17534,
	"./placeholder/ud-insider-map.png": 34305,
	"./placeholder/ud-welcome.png": 17570,
	"./placeholder/vaudoise-black.svg": 67843,
	"./placeholder/vaudoise-desktop-inverted.svg": 89940,
	"./placeholder/vaudoise-desktop.svg": 49682,
	"./placeholder/vaudoise-footer-desktop.svg": 15148,
	"./placeholder/vaudoise-mobile-inverted.svg": 14930,
	"./placeholder/vaudoise-mobile.svg": 40240,
	"./placeholder/watch.jpg": 30701,
	"./play.svg": 37409,
	"./plectrum.svg": 18375,
	"./plus.svg": 37807,
	"./previous.svg": 23272,
	"./search.svg": 34691,
	"./shuffle.svg": 6378,
	"./socials/facebook.png": 17911,
	"./socials/instagram.png": 24879,
	"./socials/outline-dark-facebook-48.png": 21186,
	"./socials/outline-dark-instagram-48.png": 50514,
	"./socials/outline-dark-linkedin-48.png": 25812,
	"./socials/outline-dark-pinterest-48.png": 11628,
	"./socials/outline-dark-spotify-48.png": 91700,
	"./socials/outline-dark-twitter-48.png": 69385,
	"./socials/outline-dark-youtube-48.png": 89879,
	"./socials/tiktok.png": 12637,
	"./socials/twitter.png": 55758,
	"./socials/x.png": 92723,
	"./socials/youtube.png": 2640,
	"./text-area.svg": 18592,
	"./twitter.svg": 32036,
	"./upload.svg": 57020,
	"./whatsapp.svg": 45749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11068;